(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["waitlist-form"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__alinaWaitlist) return;
    window.__alinaWaitlist = true;

    var JOINED_KEY = 'alina_waitlist_joined';
    var REVISION = '2024-10-15';

    function isLive() {
      try { return !!(window.Shopify && window.Shopify.theme && window.Shopify.theme.role === 'main'); }
      catch (e) { return false; }
    }

    function remember() {
      try { window.localStorage.setItem(JOINED_KEY, String(Date.now())); } catch (e) {}
    }

    function showMessage(form, text) {
      var msg = form.querySelector('[data-waitlist-msg]');
      if (!msg) return;
      msg.textContent = text || '';
      msg.hidden = !text;
    }

    function validEmail(value) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    }

    function send(email, source, product, picks) {
      var cfg = window.ALINA_WAITLIST || {};
      if (!cfg.companyId || !cfg.listId) {
        /* Not wired to Klaviyo yet. A theme preview lets the form finish so the design can be
           reviewed. The live site must fail loudly rather than pretend to sign someone up. */
        return isLive() ? Promise.reject(new Error('not-wired')) : Promise.resolve();
      }
      var props = { waitlist_source: source };
      if (product) props.waitlist_product = product;
      if (picks.length) props.waitlist_products = picks.join(', ');
      var body = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'December Waitlist',
            profile: { data: { type: 'profile', attributes: { email: email, properties: props } } }
          },
          relationships: { list: { data: { type: 'list', id: cfg.listId } } }
        }
      };
      return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(cfg.companyId), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': REVISION },
        body: JSON.stringify(body)
      }).then(function (res) {
        if (!res.ok) throw new Error('klaviyo-' + res.status);
      });
    }

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.matches || !form.matches('[data-waitlist-form]')) return;
      e.preventDefault();

      var input = form.querySelector('input[name="email"]');
      var button = form.querySelector('button[type="submit"]');
      var email = (input.value || '').trim();

      showMessage(form, '');
      input.removeAttribute('aria-invalid');

      if (!validEmail(email)) {
        input.setAttribute('aria-invalid', 'true');
        showMessage(form, 'Please enter a valid email address.');
        input.focus();
        return;
      }

      var picks = Array.prototype.map.call(
        form.querySelectorAll('input[name="products"]:checked'),
        function (box) { return box.value; }
      );

      button.disabled = true;
      send(email, form.getAttribute('data-source'), form.getAttribute('data-product'), picks)
        .then(function () {
          remember();
          var wrap = form.closest('[data-waitlist]');
          var done = wrap && wrap.querySelector('[data-waitlist-done]');
          form.hidden = true;
          if (done) {
            done.hidden = false;
            try { done.focus({ preventScroll: true }); } catch (err) {}
          }
          document.dispatchEvent(new CustomEvent('waitlist:joined', {
            detail: { email: email, source: form.getAttribute('data-source') }
          }));
        })
        .catch(function () {
          button.disabled = false;
          showMessage(form, 'Something went wrong. Please try again, or email hello@alinaskincare.com.');
        });
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
